/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';

import { Grid } from "@material-ui/core";
import { withTranslation } from 'react-i18next';

import CartRouteComponent from "../components/Nav/CartRouteComponent";
import OrderFormComponent from "../components/Forms/OrderFormComponent";
import { useThemeData } from '../context/ThemeDataContext'
import {usePhotoBaseData} from '../context/PhotoBasicDataContext'
import GeneralText from "../components/Fonts";

function Addressform(props) {
    const {photographerType} = useThemeData();
    const {font_family, primary_color_2} = useThemeData().themeData.site.theme;
    const userid = usePhotoBaseData().photoDefaultSettings.user_id;
    const equestrianPS = photographerType === 'equestrianphotoservice' ? 'equestrianphotoservice' : undefined;
    const login_name = equestrianPS !== undefined ? props.location.state.login_name.login_name : localStorage.getItem('login_name');
    const user_id = equestrianPS !== undefined ? props.location.state.user_id : userid;

    return (<Grid item lg={12} md={12} 
        className="addressform" 
    style={{
        fontFamily: `${font_family}`,
        color: `${primary_color_2}`,
        textAlign: '-webkit-center'
    }}>

        <GeneralText
              variant="h3"
              gutterBottom={true}
            >
              {props.t('addressform:Address form')}
        </GeneralText>

        {equestrianPS === undefined &&
            <Grid
                container
                direction="row"
                className="text-center"
                style={{ justifyContent: "center" }}
            >
                <Grid item lg={6} md={6} xs={12}>
                    <CartRouteComponent activeStep={"2"} />
                </Grid>
            </Grid>
        }
        <div className="justify-content-center">

            <div className="addressform-body"
                style={{
                    fontFamily: `${font_family}`,
                    color: `${primary_color_2}`
                }}>

                <OrderFormComponent 
                    {...props} 
                    user_id={user_id} 
                    login_name={login_name} 
                />
                
            </div>
        </div>
    </Grid>
    );

}


export default React.memo(withTranslation(['message', 'addressform'])(Addressform));
